import { render, staticRenderFns } from "./goodsColumn.vue?vue&type=template&id=730f5d66&scoped=true&"
import script from "./goodsColumn.vue?vue&type=script&lang=js&"
export * from "./goodsColumn.vue?vue&type=script&lang=js&"
import style0 from "./goodsColumn.vue?vue&type=style&index=0&id=730f5d66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730f5d66",
  null
  
)

export default component.exports